import { onMounted, onUnmounted } from 'vue'
//import { LoggedUserService, ILoggedUserService } from '../services/LoggedUserService';

//const loggedUserService = inject<ILoggedUserService>('loggedUserService')!;
//LoggedUserService.getInstance().getSessionToken


let inactivityTimer: number | undefined;
let throttleTimer: number | undefined;
let sessionMonitor: number | undefined;
let lastCallTime = 0;

export default {
  //
  // Tracks user activity (keyboard, mouse) and triggers callbacks.
  //
  tracker: function userActivityTracker(
    extendSessionCallback: () => void,
    logoutCallback?: () => void,
    options?: {
      debounceMs?: number
      inactivityTimeoutMs?: number
    }
  ): void {

    const debounceMs = options?.debounceMs ?? 30_000 // 30 seconds between backend pings
    //----------------------------------------------------------------------------------------------
    const startMonitoringSessionExiration = () => {
      const intervalMs = 10_000; // 10 seconds in milliseconds

      if (!logoutCallback) {
        return;
      }

      sessionMonitor = window.setInterval(() => {
        const now = Date.now();
        const expiresOn = sessionStorage.getItem("sessionExpire");
        if (expiresOn) {

          const expireTS = new Date(expiresOn);
          const remainedSec = (expireTS.getTime() - now) / 1000;
          console.log("" + remainedSec + " to logout");

          if (remainedSec <= 0) {
            clearInterval(sessionMonitor)
            sessionMonitor = undefined
            logoutCallback();
          }
        }
      }, intervalMs);

    }
    //----------------------------------------------------------------------------------------------
    const handleActivity = () => {

      const now = Date.now()

      // Throttle extendSessionCallback to run at most once every debounceMs
      if (now - lastCallTime >= debounceMs) {
        extendSessionCallback()
        lastCallTime = now
      } else {
        // Schedule one more call at the end of the current throttle window
        if (!throttleTimer) {
          const remaining = debounceMs - (now - lastCallTime)
          throttleTimer = window.setTimeout(() => {
            extendSessionCallback();
            lastCallTime = Date.now()
            throttleTimer = undefined
          }, remaining)
        }
      }

      // Reset inactivity timer (used for logout)
      //resetInactivityTimer()
    }
    //----------------------------------------------------------------------------------------------
    //const resetInactivityTimer = () => {
    //  if (inactivityTimer) window.clearTimeout(inactivityTimer)
    //  if (logoutCallback) {
    //    inactivityTimer = window.setTimeout(() => {
    //      logoutCallback()
    //    }, inactivityTimeoutMs)
    //  }
    //}
    //----------------------------------------------------------------------------------------------
    onMounted(() => {
      window.addEventListener('mousemove', handleActivity);
      window.addEventListener('keydown', handleActivity);
      //resetInactivityTimer();
      startMonitoringSessionExiration();;
    })
    //----------------------------------------------------------------------------------------------
    onUnmounted(() => {
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      if (inactivityTimer) window.clearTimeout(inactivityTimer);
      if (throttleTimer) window.clearTimeout(throttleTimer);
      if (sessionMonitor) window.clearInterval(sessionMonitor);
    })
    //----------------------------------------------------------------------------------------------
  }
}
